import { render } from "./NewOrderZone.vue?vue&type=template&id=9a2555f6&ts=true"
import script from "./NewOrderZone.ts?vue&type=script&lang=ts"
export * from "./NewOrderZone.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__